
import { defineComponent } from 'vue'

import Logo from '@/components/Icons/Logo.vue'
import Banner from '@/pages/Home/components/Banner.vue'
import ShareInfo from '@/pages/Home/components/ShareInfo.vue'
import Challenges from '@/pages/Home/components/Challenges.vue'
import Footer from '@/pages/Home/components/Footer.vue'

export default defineComponent({
  components: {
    Logo,
    Banner,
    ShareInfo,
    Challenges,
    HomeFooter: Footer,
  },
})
